import "./PaginateControls.css";


const PaginateControls = (props) => {

    return(
        <>
        <div className="paginate-controls-div">
            {
                props.prev ?
                <button className="green-btn" onClick={() => props.callback(-1)}>Anterior</button>
                :
                <></>
            }
            {
                props.next ?
                <button className="green-btn" onClick={() => props.callback(+1)}>Siguiente</button>
                :
                <></>
            }
        </div>
        </>
    );
}

export default PaginateControls;